import noop from 'lodash/noop'
import clsx from 'clsx'

import Label from 'app/shared-components/Label'
import DropZone from 'app/shared-components/DropZone'

import AttachmentLink from './AttachmentLink'
import AttachmentType from './Attachment.types'

import useStyles from './Attachment.styles'

type Props = {
    title?: string,
    name?: string,
    value?: AttachmentType[],
    onChange: (...args: any) => void,
    className?: string,
    upload?: boolean,
    editable?: boolean,
    disabled?: boolean,
    onDelete?: (id: number) => void,
    required?: boolean,
    multiple?: boolean,
    acceptType?: string,
}

const defaultProps: Partial<Props> = {
    title: 'Attachments',
    name: 'attachments',
    value: [],
    className: '',
    upload: true,
    editable: false,
    disabled: false,
    onDelete: noop,
    required: false,
    multiple: true,
    acceptType: undefined,
}
const Attachment = ({
    title,
    name,
    value,
    className,
    onChange,
    upload,
    editable,
    disabled,
    onDelete,
    required,
    multiple,
    acceptType,
}: Props) => {
    const {
        classes,
    } = useStyles()

    const emptyState = disabled ? '-' : ''

    return (
        <div
            className={clsx(classes.root, className)}
            data-testid={`attachment-${name}`}
        >
            <Label
                title={title}
            />
            {(!disabled)
                && (

                    <DropZone
                        required={required}
                        disabled={disabled || !upload}
                        onChange={onChange}
                        multiple={multiple}
                        acceptType={acceptType}
                    />
                )}
            <div className={classes.linksContainer}>
                {value.length ? value.map((file) => {
                    return (
                        <AttachmentLink
                            key={`menu-link-${file.id}`}
                            file={file}
                            editable={editable}
                            onDelete={onDelete}
                        />
                    )
                }) : emptyState}
            </div>
        </div>
    )
}

Attachment.defaultProps = defaultProps

export default Attachment
